module.exports = {"meta":{"lead":"Comprendre l'IA pour la démystifier"},"menu":{"home":"Home"},"translations":"Translations config"};